export default __webpack_public_path__ + "static/media/document.287381e2.hbs";